module.exports = __webpack_public_path__ + "img/log-hours.fd6d6cc2.svg";